var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('hamburger',{staticClass:"hamburger-container",attrs:{"id":"hamburger-container","is-active":_vm.sidebar.opened},on:{"toggleClick":_vm.toggleSideBar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }